import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MergeTagPickerComponent } from './merge-tag-picker.component';
import { MergeTagTreeNodeComponent } from './merge-tag-tree-node/merge-tag-tree-node.component';
import { MergeTagPickerOverlayComponent } from './merge-tag-picker-overlay/merge-tag-picker-overlay.component';
import { MergeTagPickerInputBaseComponent } from './merge-tag-picker-input-base/merge-tag-picker-input-base.component';

@NgModule({
	imports: [
		CommonModule,
		ReactiveFormsModule,
		MatFormFieldModule,
		MatInputModule,
		MatIconModule,
		MatButtonModule
	],
	declarations: [
		MergeTagPickerComponent,
		MergeTagTreeNodeComponent,
		MergeTagPickerOverlayComponent,
		MergeTagPickerInputBaseComponent
	],
	exports: [MergeTagPickerComponent]
})
export class MergeTagPickerModule {}
